/*
 * Copyright (c) 2026 Roboto Technologies, Inc.
 */
import * as React from "react";

import { AiCreditUsage } from "@/shared/domain/limits";

import { formatAiCreditUsage } from "./aiCreditFormatter";
import { UsageLimit } from "./UsageLimit";

export interface AiCreditUsageCardProps {
  usage: AiCreditUsage;
}

/**
 * Settings → Usage card showing the org's AI credit consumption for the
 * current month against the configured monthly cap. When the org's cap is the
 * "unlimited" sentinel, the card surfaces "Unlimited" copy instead of a
 * progress bar so users aren't shown a meaningless percentage.
 */
export const AiCreditUsageCard: React.FC<AiCreditUsageCardProps> = ({
  usage,
}) => {
  const { currentValue, limitValue, currentPercent } =
    formatAiCreditUsage(usage);

  return (
    <UsageLimit
      title="AI Credits"
      currentValue={currentValue}
      currentPercent={currentPercent}
      limitValue={limitValue}
      monthly={true}
    />
  );
};
